<div class="ticket row">
  <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
    <div
      *ngIf="
        order.id == '$$$$' || order.isBeingTransferred || order.isTransferred
      "
      class="container_"
    >
      <div class="tag">
        {{
          order.id == "$$$$" &&
          !order.isBeingTransferred &&
          !order.isTransferred
            ? ("Sport.TicketNotActive" | translate)
            : order.isBeingTransferred
            ? ("Sport.isBeningTransferred" | translate)
            : ("Sport.isTransferred" | translate)
        }}
        <p
          *ngIf="
            order.id == '$$$$' &&
            !order.isBeingTransferred &&
            !order.isTransferred
          "
          style="font-size: 8px"
          class="mb-0"
        >
          {{ "Sport.BeforeXHours" | translate : { value: hours } }}
        </p>
      </div>
      <img
        [src]="[
          'https://api.qrserver.com/v1/create-qr-code/?color=cecece&data=' +
            order.id +
            '&margin=30&height=100'
        ]"
        alt=""
        class="qr-image"
      />
    </div>
    <img
      *ngIf="
        order.id != '$$$$' && !order.isBeingTransferred && !order.isTransferred
      "
      src="{{
        'https://api.qrserver.com/v1/create-qr-code/?data=' +
          order.id +
          '&margin=30&height=100'
      }}"
      alt=""
      class="qr-image"
    />
  </div>
  <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
    <div class="description-tilte">
      {{ helpers.getElementTranslatedName(ticket) }}
    </div>

    <div *ngIf="order.section" class="description-subtitle">
      {{ "Sport.Section" | translate }}
      {{ order?.section }} ,
      {{ "Sport.Row" | translate }}
      {{ order?.row }} ,
      {{ "Sport.Seat" | translate }}
      {{ order?.seat }}
    </div>
    <div *ngIf="!order.section" class="description-subtitle">
      {{ "Sport.NoSeatChosen" | translate }}
    </div>
  </div>
  <div
    class="col-sm-12 col-md-6 col-lg-3 col-xl-3 last-col"
    *ngIf="ticket.needToPay"
  >
    <div class="description-tilte">
      <span
        *ngIf="ticket.price !== 0"
        [innerHTML]="
          ticket.price | customCurrency : 'SAR' : 'symbol' : '#555770' : 24
        "
      ></span>
      <span *ngIf="ticket.price === 0" style="color: #555770; font-size: 18px">
        {{ "free" | translate }}
      </span>
    </div>

    <button
      type="button"
      *ngIf="!order.isBeingTransferred && !order.isTransferred"
      class="action-btn"
      (click)="
        order.id === '$$$$'
          ? transferDisabledTicket(order.ticketNumber)
          : transferTicket(order.id)
      "
    >
      <img src="/assets/images/icons/green-share.svg" />
    </button>

    <button
      type="button"
      *ngIf="order.isBeingTransferred"
      class="action-btn"
      (click)="cancelTicket([order.transferredId])"
    >
      <img src="assets/images/events/close.png" />
    </button>
  </div>
</div>
